// extracted by mini-css-extract-plugin
export default {"chips":"A5k_f9","chips_invert":"OlKvnb","chips__icon":"fCmPCZ","chips__subTitle":"zLu6Ex","chips__label":"XwICEl","chips_disabled":"OvRIyD"};